import Cookies from 'js-cookie'
import { TRACK_VISIT_SESSION_COOKIE } from './visitSessionCookieConstants'

/**
 * Gets an existing visit session id without setting or refreshing it
 * @returns The saved visit session id, if it is set, or undefined otherwise
 */
export const getVisitSessionId = () => Cookies.get(TRACK_VISIT_SESSION_COOKIE)
